/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a528a130"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "card-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "系统签名", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*支持jks和keystore格式签名文件;", -1));
import { apiUsdkGetChannelSign, apiUsdkGetChannelCommonConfig, apiUsdkGetPublicSign, apiUsdkSaveChannelSign } from '@/api/usdk';
import { UseComProps } from './hooks';
import Icon from './icon.vue';
import SaveBtn from './saveBtn.vue';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'sign',
  props: UseComProps(),
  setup(__props) {
    const props = __props;
    const isEdit = ref(false);
    const form = ref({
      url: [],
      name: '',
      md5Val: '',
      key_store_password: '',
      key_alias_password: '',
      key_alias: ''
    });
    const oldForm = ref();
    const isSignChange = ref(false);
    const handleUploadSuccess = () => {
      isSignChange.value = true;
      form.value.md5Val = '';
    };
    const loading = ref(false);
    const getSign = status => {
      const api = status ? apiUsdkGetChannelSign : apiUsdkGetPublicSign;
      const params = status ? {
        gid: props.gid,
        cid: props.channel.cid
      } : {
        gid: props.gid
      };
      loading.value = true;
      api(params).then(res => {
        if (res.code === 0 && res.data) {
          form.value = res.data;
          form.value.url = [{
            url: res.data.url,
            name: res.data.title
          }];
          if (form.value.name && form.value.name.length !== 40) {
            form.value.name = '-';
          }
        }
      }).finally(() => {
        loading.value = false;
        oldForm.value = JSON.parse(JSON.stringify(form.value));
      });
    };
    watch(() => props.channel, val => {
      if (val.cid) {
        getSign(val.sign_status);
      }
    }, {
      immediate: true
    });
    // 保存签名
    const formRef = ref();
    const confirmLoading = ref(false);
    const handleClick = type => {
      if (type === 'edit') {
        isEdit.value = true;
        return;
      } else if (type === 'cancel') {
        isEdit.value = false;
        return;
      } else {
        handleSubmit();
      }
    };
    const handleSubmit = () => {
      const dict = {
        name: {
          name: 'SHA1'
        },
        md5Val: {
          name: 'md5'
        },
        title: {
          name: '文件名'
        },
        key_store_password: {
          name: 'key_store_password'
        },
        key_alias_password: {
          name: 'key_alias_password'
        },
        key_alias: {
          name: 'key_alias'
        },
        url: {
          name: '文件链接'
        }
      };
      formRef.value.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(form.value));
          params.cid = props.channel.cid;
          params.gid = props.gid;
          if (params.url && params.url.length) {
            params.url = params.url[0].url;
          } else {
            params.url = '';
          }
          const fn = status => {
            confirmLoading.value = true;
            apiUsdkSaveChannelSign({
              status,
              ...params
            }).then(res => {
              if (res.code === 0) {
                isEdit.value = false;
                customDataReport({
                  eventName: 'set_system_sign',
                  dict,
                  before: oldForm.value,
                  after: form.value,
                  operatePath: '出包-渠道配置-基础配置-系统签名',
                  gid: props.gid
                });
                oldForm.value = JSON.parse(JSON.stringify(form.value));
              }
            }).finally(() => {
              confirmLoading.value = false;
            });
          };
          ElMessageBox.confirm(`<div>
        <div style="font-weight: 600">
          你正在编辑修改系统签名，你可以选择将修改后的签名文件一键应用到本游戏的全部渠道或生效于当前渠道!
        </div>
        <ul>
          <li>· 【一键应用到全部渠道】：本游戏当前的所有渠道以及后续新添加的渠道都将使用该签名文件</li>
          <li>· 【仅修改当前渠道】：仅修改当前渠道，则对其他渠道无影响</li>
        </ul>
      </div>`, '提示', {
            customStyle: {
              width: '650px'
            },
            confirmButtonText: '一键应用于全部渠道',
            cancelButtonText: '仅修改当前渠道',
            dangerouslyUseHTMLString: true,
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            fn(0);
          }).catch(action => {
            if (action === 'cancel') {
              fn(1);
            }
          });
        }
      });
    };
    const channelCommonInfo = ref(null);
    const getCommonInfo = () => {
      apiUsdkGetChannelCommonConfig({
        gid: props.gid,
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          channelCommonInfo.value = res.data;
        }
      });
    };
    onMounted(() => {
      getCommonInfo();
    });
    return (_ctx, _cache) => {
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      return _openBlock(), _createElementBlock("div", null, [_ctx.channel.plat === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, !_unref(isEdit) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "btn-color cp",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('edit'))
      }, "[编辑]")) : (_openBlock(), _createBlock(SaveBtn, {
        key: 1,
        loading: _unref(confirmLoading),
        onCancel: handleClick,
        onSave: handleClick
      }, null, 8, ["loading"]))])) : _createCommentVNode("", true), _ctx.channel.plat === 0 ? (_openBlock(), _createBlock(_component_el_form, {
        key: 1,
        class: "marginT20",
        model: _unref(form),
        ref_key: "formRef",
        ref: formRef,
        style: {
          "width": "668px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "签名文件",
          prop: "url",
          rules: {
            required: true,
            message: '请上传签名文件',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_u_upload, {
            text: _unref(form).url ? "重新上传" : "",
            modelValue: _unref(form).url,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).url = $event),
            accept: ".keystore,.jks",
            timestamp: "",
            limit: 1,
            disabled: !_unref(isEdit),
            onSuccess: handleUploadSuccess
          }, {
            tip: _withCtx(() => [_hoisted_3]),
            _: 1
          }, 8, ["text", "modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "MD5"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).md5Val,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).md5Val = $event),
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "SHA1",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).name = $event),
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "key_store_password",
          prop: "key_store_password",
          rules: {
            required: true,
            message: '请输入key_store_password',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).key_store_password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).key_store_password = $event),
            disabled: !_unref(isSignChange)
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "key_alias_password",
          prop: "key_alias_password",
          rules: {
            required: true,
            message: '请输入key_alias_password',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).key_alias_password,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).key_alias_password = $event),
            disabled: !_unref(isSignChange)
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "key_alias",
          prop: "key_alias",
          rules: {
            required: true,
            message: '请输入key_alias',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).key_alias,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).key_alias = $event),
            disabled: !_unref(isSignChange)
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])) : _createCommentVNode("", true), _createVNode(Icon, {
        gid: _ctx.gid,
        channel: _ctx.channel,
        commonInfo: _unref(channelCommonInfo),
        class: "marginT10"
      }, null, 8, ["gid", "channel", "commonInfo"])]);
    };
  }
});